import { Pipe, PipeTransform } from '@angular/core'
import { IServiceOrder } from '../interface'
@Pipe({
  name: 'formatQty',
})
export class FormatQtyPipe implements PipeTransform {
  transform(value: IServiceOrder, type = 'qty'): any {
    const version = this.getOrderVersion(value)
    if (version === 1) {
      if (type === 'unit') {
        return value.samples ? 'Samples' : value.acreage ? 'Acres' : 'NA'
      }
      return value.samples || value.acreage || 'NA'
    } else {
      if (type === 'unit') {
        return value.unit
      }
      return value.qty
    }
  }

  private getOrderVersion(value: IServiceOrder) {
    let version = 2
    if (value.acreage || value.samples) {
      version = 1
    }
    return version
  }
}
